// Path: libs/core/shell/src/lib/layout/public/shell-header/shell-header.component.ts
import { Component, Inject, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeApplierService } from '../../../theme/theme-applier.service';
import { DrawerService } from '@cardapio-online/drawer';
import { CartService } from '../../../cart/cart.service';
import { BrandKernelService } from '@cardapio-online/theme';

@Component({
  selector: 'lib-shell-header',
  templateUrl: './shell-header.component.html',
  styleUrl: './shell-header.component.scss',
})
export class ShellHeaderComponent {
  private clickCount = 0;
  private timer: ReturnType<typeof setTimeout> | null = null;

  protected readonly brand = inject(BrandKernelService);

  @Input() showButtons = true;
  @Input() compactVisible = true;

  protected readonly cartCount = this.cart.count;

  constructor(
    private readonly router: Router,
    private readonly theme: ThemeApplierService,
    @Inject(DrawerService) private readonly drawer: DrawerService,
    private readonly cart: CartService
  ) {}

  onBrandClickToLogin(ev: MouseEvent) {
    ev.preventDefault();

    this.clickCount += 1;

    if (this.timer) clearTimeout(this.timer);

    this.timer = setTimeout(() => {
      this.clickCount = 0;
      this.timer = null;
      this.router.navigateByUrl('/');
    }, 350);

    if (this.clickCount >= 3) {
      if (this.timer) clearTimeout(this.timer);
      this.clickCount = 0;
      this.timer = null;
      this.router.navigateByUrl('/login');
    }
  }

  toggleTheme() {
    this.theme.toggle();
  }

  openCart() {
    this.drawer.toggle('cart');
  }

  openConfig() {
    this.drawer.toggle('config');
  }
}